"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenu = exports.useDescendants = exports.useConfirm = exports.useMenuProviderProps = void 0;
const react_1 = require("react");
const compound_components_1 = require("@clds/compound-components");
const childData_1 = require("../childData");
const MenuItem_1 = require("../MenuItem");
const useMenuProviderProps = (registry, state) => ({
    registry,
    select: state.select,
    focusedId: state.focusedId,
    selectedId: state.selectedId,
});
exports.useMenuProviderProps = useMenuProviderProps;
const useConfirm = (registry, state) => {
    const getChildData = (id) => {
        const data = registry.get(id);
        if (!data) {
            throw new Error(`Cannot find data for item of id ${String(id)}. Please remember to use useRegisterChildData() hook in your list item`);
        }
        return data;
    };
    return () => {
        var _a, _b;
        state.select(state.focusedId);
        if (state.focusedId !== compound_components_1.unselect) {
            (_b = (_a = getChildData(state.focusedId)).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    };
};
exports.useConfirm = useConfirm;
const useDescendants = () => {
    const { ref, result } = (0, compound_components_1.useQuerySelectorAll)(`[${MenuItem_1.ID_ATTRIBUTE_NAME}]`);
    const ids = (0, react_1.useMemo)(() => result.map((element) => String(element.getAttribute(MenuItem_1.ID_ATTRIBUTE_NAME))), [result]);
    return { ref, ids };
};
exports.useDescendants = useDescendants;
const useMenu = (state) => {
    const registry = (0, childData_1.useChildRegistry)();
    const { ref, ids } = (0, exports.useDescendants)();
    const confirm = (0, exports.useConfirm)(registry, state);
    const navigationHandlers = (0, compound_components_1.useListNavigationHandlers)({
        activeItem: state.focusedId,
        onActiveItemChange: state.setFocusedId,
        items: ids,
    });
    const { focusableProps } = (0, compound_components_1.useListNavigation)(Object.assign(Object.assign({}, navigationHandlers), { onEscape: state.cancel, onEnter: confirm, onSpace: confirm }));
    const menuProviderProps = (0, exports.useMenuProviderProps)(registry, state);
    return {
        descendantsParentRef: ref,
        focusableProps,
        menuProviderProps,
    };
};
exports.useMenu = useMenu;
//# sourceMappingURL=useMenu.js.map